import { initCardLinks } from "./teaser-tiles";
import { initObfuscatedContactLinks } from "./helpers";
import { initHeroSlider } from "./hero-slider";
import { initImageGallery } from "./image-gallery";

const initHwkBlocks = () => {
  initCardLinks();
  initObfuscatedContactLinks();
  initHeroSlider();
  initImageGallery();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHwkBlocks);
} else {
  initHwkBlocks();
}
